// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\SessionResponse

import { hydrateSessionEngine, type SessionEngine, type SessionEngineApiResponse } from './sessionEngine.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type SessionApiResponse = {
	id: string;
	name: string;
	color: string;
	engine: SessionEngineApiResponse;
	maxBooking: number;
	parentId: string;
	followAllAreas: boolean;
	areas: string[];
	archivedAt: string | null;
	conferenceProvider: string | null;
	googleConferenceAuthId: number | null;
	conferenceUrl: string | null;
};

export type Session = {
	id: string;
	name: string;
	color: string;
	engine: SessionEngine;
	maxBooking: number;
	parentId: string;
	followAllAreas: boolean;
	areas: string[];
	archivedAt: DateTime | null;
	conferenceProvider: string | null;
	googleConferenceAuthId: number | null;
	conferenceUrl: string | null;
};

export function hydrateSession(data: SessionApiResponse): Session {
	return {
		...data,
		engine: hydrateSessionEngine(data.engine),
		archivedAt: DateTimefromISO(data.archivedAt),
	};
}